import { Col, List, Row, Skeleton } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TemplateDocumentButton } from '../../../components/TemplateDocumentButton/TemplateDocumentButton';
import { templateUseCase } from '../../invoices/customers/utils/templateUseCase';

/**
 * Renders a list of documents for a subscription.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.invoice - The invoice object.
 * @param {boolean} props.isLoading - Indicates if the list is loading.
 * @param {Array} props.pensioner - The list of pensioners.
 * @returns {JSX.Element} The rendered component.
 */
export const ListDocument = ({ invoice, isLoading, pensioner }) => {
  const { invoiceId, reference, status } = invoice;
  const { t } = useTranslation();

  return (
    <Row>
      <Col xs={24} span={16}>
        <List
          className="demo-loadmore-list"
          loading={isLoading}
          itemLayout="horizontal"
          dataSource={pensioner}
          renderItem={(item) => (
            <List.Item
              actions={[
                <TemplateDocumentButton
                  key="download"
                  parameters={[
                    {
                      collection: 'Customerinvoice',
                      documentId: invoiceId
                    }
                  ]}
                  use_case={templateUseCase({
                    type: 'SUBSCRIPTION',
                    status: status || 'WAITING'
                  })}
                  button_text="customerinvoices.show.buttons.download"
                  downloadName={reference || 'document'}
                />
              ]}
            >
              <Skeleton avatar title={false} loading={false} active>
                <List.Item.Meta
                  avatar={<CheckCircleOutlined />}
                  description={t('subscriptions.subscription_invoice_wording', {
                    name: item.name,
                    reference
                  })}
                />
              </Skeleton>
            </List.Item>
          )}
        />
      </Col>
    </Row>
  );
};

ListDocument.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  invoice: PropTypes.shape({
    invoiceId: PropTypes.string,
    reference: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  pensioner: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
